import { HeaderContext as LibHeaderContext } from '@tanstack/react-table';
import { influencer } from '@round/api';
import { getTableMetaHelper } from '@round/ui-kit';
import { CellContext, Meta as BaseMeta } from 'Modules/Plans/CreatorSearch/components/CreatorExploreTable/helpers';

export type HeaderContext = LibHeaderContext<CellContext['row']['original'], unknown>;

export type Meta = BaseMeta & {
    /** The pool being viewed; the Accounts cell reads it to decide which accounts belong to this pool. */
    poolId: number | null | undefined;
    /**
     * TODO(ROU-1264): creatorbase-ui's VirtualizedTable doesn't forward react-table's
     * row-selection state yet. Once it does, drop this for that API, keyed on the
     * creator id rather than the row index.
     */
    selectedCreatorIds: Set<string>;
    onCreatorToggle: (creatorId: string) => void;
    onSelectAll: (creatorIds: string[]) => void;
    onClearSelection: () => void;
    onRemoveCreators: (creators: influencer.CreatorSearchResult[]) => void;
};

export const getTableMeta = getTableMetaHelper<Meta>();
